var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M12.088 2.119C9.457-.594 5.138-.703 2.375 1.875 1.053 3.11.281 4.823.231 6.631.174 8.44.85 10.193 2.106 11.494c2.625 2.723 6.948 2.837 9.713.256 1.323-1.236 2.095-2.952 2.144-4.762.048-1.81-.632-3.564-1.888-4.87h.013zm-1.113 8.75c-2.273 2.107-5.817 1.999-7.956-.244-1.022-1.065-1.574-2.494-1.534-3.97.04-1.474.669-2.872 1.746-3.88C5.497.663 9.038.757 11.188 2.987c1.022 1.065 1.576 2.494 1.536 3.97-.04 1.475-.67 2.873-1.749 3.88v.032zm8.625 8.069l-6.475-6.732c-.155-.16-.384-.226-.601-.172-.217.054-.389.22-.45.434-.062.215-.004.446.151.607l6.469 6.731c.117.123.28.193.45.194.162-.002.318-.065.437-.175.121-.115.191-.273.195-.44.003-.167-.06-.328-.176-.448z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#B0AECA",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0 20 20 0 20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c4cb685444bf18fb707540d9c122175b.svg";
export { ForwardRef as ReactComponent };